import { Component, Inject, ChangeDetectionStrategy } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { AddressByGoogle } from '@grupo-constant/next-dtype/types';
import { TranslocoModule, TranslocoService } from '@ngneat/transloco';
import { FuseConfirmationService } from '../../../@fuse/services/confirmation/confirmation.service';

@Component({
    selector: 'address-list-dialog',
    templateUrl: './address-list-dialog.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [MatButtonModule, MatIconModule, TranslocoModule]
})
export class AddressListDialogComponent {

    selected: AddressByGoogle;

    constructor(
        @Inject(MAT_DIALOG_DATA) public data: {
            addressList: AddressByGoogle[];
        },
        public dialogRef: MatDialogRef<AddressListDialogComponent>,
        private _fuseConfirmationService: FuseConfirmationService,
        private transloco: TranslocoService
    ) { }

    save() {
        const confirmDialog = this.openConfirmDialog(this.transloco.translate('selectAddressConfirm'));
        confirmDialog.afterClosed().subscribe((confirm) => {
            if (confirm === 'confirmed') {
                this.closeDialog(this.selected);
            }
        });
    }

    closeDialog(result?: any) {
        this.dialogRef.close(result);
    }

    /**
     * Track by function for ngFor loops
     *
     * @param index
     * @param item
     */
    trackByFn(index: number, item: AddressByGoogle): any {
        return item.placeId ?? index;
    }

    private openConfirmDialog(message: string) {
        return this._fuseConfirmationService.open({
            title: this.transloco.translate('warning'),
            message: message,
            actions: {
                confirm: {
                    label: this.transloco.translate('confirm')
                },
                cancel: {
                    label: this.transloco.translate('cancel')
                }
            }
        });
    }

}
